import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("UI Error caught by boundary:", error, info);
    // Known Radix UI bug triggered by browser translation extensions: auto-recover by reloading
    const msg = String(error?.message || "");
    if (msg.includes("removeChild") || msg.includes("insertBefore") || msg.includes("appendChild")) {
      // Mark a flag so we don't reload in a loop
      try {
        const key = "__radix_dom_reload__";
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, "1");
          setTimeout(() => window.location.reload(), 300);
        }
      } catch (e) {
        /* ignore */
      }
    }
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F4F5]">
        <div className="max-w-md w-full bg-white border border-red-200 rounded-sm p-6">
          <div className="mono text-[10px] tracking-[0.25em] text-red-600 mb-2">FEHLER</div>
          <h2 className="font-display text-xl uppercase mb-2">Etwas ist schiefgelaufen</h2>
          <p className="text-sm text-zinc-600 mb-4">
            In der Seite ist ein unerwarteter Fehler aufgetreten. Du kannst die Seite neu laden
            oder zur Startseite zurückkehren.
          </p>
          {this.state.error?.message && (
            <pre className="bg-zinc-50 border border-zinc-200 rounded-sm p-2 text-[11px] mono text-zinc-700 overflow-auto max-h-40 mb-4">
              {String(this.state.error.message)}
            </pre>
          )}
          <div className="flex gap-2">
            <button
              onClick={() => window.location.reload()}
              className="bg-[#F97316] hover:bg-[#EA580C] text-white px-4 h-10 rounded-sm font-semibold tracking-wide"
              data-testid="error-reload-button"
            >
              SEITE NEU LADEN
            </button>
            <button
              onClick={() => {
                this.reset();
                window.location.href = "/";
              }}
              className="border border-zinc-400 px-4 h-10 rounded-sm font-medium hover:bg-zinc-50"
              data-testid="error-home-button"
            >
              Startseite
            </button>
          </div>
        </div>
      </div>
    );
  }
}
